export const MessageRoomsEmpty = {
    messageRoomsForClientMainText: "メッセージルームがありません。",
    messageRoomsForClientDescriptionText: "掲載案件にエントリーがあると、ここで登録者とやり取りが開始できます。",
    messageRoomsForClientBtnText: "案件をみる",

    messageRoomsForCustomerMainText: "メッセージルームがありません。",
    messageRoomsForCustomerDescriptionText: "案件のエントリーをすると、企業担当者とメッセージのやり取りができるようになります。",
    messageRoomsForCustomerBtnText: "案件をみる",
};




// WEBPACK FOOTER //
// ./src/config/view_const/message_rooms.ts